export const CopyRight = () => {
  return (
    <div className='text-center text-[0.8rem] text-white'>
      <small>Copyright © 2024 KLEW All Rights Reserved.</small>
    </div>
  );
};
